import React from 'react';
import { Typography } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
// Helpers
import {
  formatCheckDetail,
  formatCheckTitle,
} from 'helpers/teams/cbTeamOwnershipTransfer.helpers';
// Types
import { CheckResult } from 'helpers/teams/cbTeamOwnershipTransfer.types';
// Styles
import styles from './OwnershipChecksList.module.scss';

const { Text } = Typography;

type OwnershipChecksListProps = {
  checks: CheckResult[];
};

const OwnershipChecksList = ({
  checks,
}: OwnershipChecksListProps): JSX.Element => (
  <div className={styles.checksList}>
    {checks.map((check) => {
      const detail = formatCheckDetail(check);

      return (
        <div
          key={check.code}
          className={`${styles.checkItem} ${
            check.passed ? styles.checkItemPassed : styles.checkItemFailed
          }`}
        >
          <div className={styles.checkTitle}>
            {check.passed ? (
              <CheckCircleOutlined style={{ color: '#52c41a' }} />
            ) : (
              <CloseCircleOutlined style={{ color: '#ff4d4f' }} />
            )}
            <Text strong>{formatCheckTitle(check)}</Text>
          </div>
          {detail && <Text type="secondary">{detail}</Text>}
        </div>
      );
    })}
  </div>
);

export default OwnershipChecksList;
